export default __webpack_public_path__ + "90d125d0e8a0d905bb513f0dcd43fb7b.woff?proxy=wpt-abc";